var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xs-12 p4"},[_c('note-form',{attrs:{"data":_vm.data},on:{"submit":_vm.handleSubmit},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var onSubmit = ref.onSubmit;
return [_c('j-button',{attrs:{"isLoading":_vm.isUpdateLoading},on:{"click":onSubmit}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.$t("save"))+"\n\t\t\t")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }